import React, { useEffect, useState, useRef } from 'react';
import { Button, Divider, Card, Typography } from 'antd';
import TrackWeightModal from './TrackWeightModal'; // Your existing modal component
import axios from 'axios';
import ApexChart from './ApexChart';


const { Title } = Typography;

const TrackWeightsLineChart = () => {
  const [data, setData] = useState([]);
  const [unitLabel, setUnitLabel] = useState('Weight');
  const [modalVisible, setModalVisible] = useState(false);
  const [userPreferredType, setUserPreferredType] = useState('metric');
  const [refreshTrigger, setRefreshTrigger] = useState(0);


  const handleTrackWeightSaved = () => {
    setRefreshTrigger((prev) => prev + 1)
  };


  return (
    <Card
      style={{ borderRadius: 12, overflow: 'hidden' }}
      bodyStyle={{ padding: 24 }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Title level={4} style={{ margin: 0 }}>
          Weight Tracking
        </Title>
        <TrackWeightModal preferredQuantityType={userPreferredType} visible={modalVisible} onClose={() => { setModalVisible(false); } } onSaved={handleTrackWeightSaved} />
      </div>
      <Divider style={{ margin: '16px 0' }} />
      
      <ApexChart refreshTrigger={refreshTrigger}/>

    </Card>
  );
};

export default TrackWeightsLineChart;
